module.exports = __webpack_public_path__ + "static/sport/logo.01509b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/logo.png
// module id = xpGp
// module chunks = 0